import React from 'react'
import { RiskyConfigBanner } from 'types/banners'
import RiskyConfigBannerDisabled from 'components/libs/banner/riskyConfigBanner/RiskyConfigBannerDisabled'
import RiskyConfigBannerEnabled from 'components/libs/banner/riskyConfigBanner/RiskyConfigBannerEnabled'
import appConfig from 'config/appConfig'

export interface RiskyConfigBannerSelectorProps {
  banner: RiskyConfigBanner
}

const RiskyConfigBannerSelector: React.FC<RiskyConfigBannerSelectorProps> = ({ banner }) => {
  if (!appConfig.APP.IS_ADMIN) {
    return null
  }

  switch (banner.kind) {
    case 'enabled': {
      return <RiskyConfigBannerEnabled targetUrl={banner.targetUrl} />
    }
    case 'disabled':
    default: {
      return <RiskyConfigBannerDisabled />
    }
  }
}

export default RiskyConfigBannerSelector
